import React from 'react';
import { Card, CardHeader, CardTitle } from '@/components/ui/card';
import { Tag } from '@/components/ui/tag';
import { format } from 'date-fns';

type MealPlanDayHeaderProps = {
  dayNumber: number;
  date: string;
  totalMeals: number;
  selectedMeals: number;
};

const MealPlanDayHeader: React.FC<MealPlanDayHeaderProps> = ({
  dayNumber,
  date,
  totalMeals,
  selectedMeals,
}) => {
  return (
    <Card className="bg-gradient-to-r from-blue-50 to-purple-50">
      <CardHeader>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-blue-600 text-white rounded-full flex items-center justify-center font-bold">
              {dayNumber}
            </div>
            <div>
              <CardTitle className="text-xl">
                {format(new Date(date), 'EEEE, MMMM dd, yyyy')}
              </CardTitle>
              <p className="text-gray-600">
                <span className="ml-2 text-sm">
                  • {selectedMeals}/{totalMeals} meals selected
                </span>
              </p>
            </div>
          </div>
          <Tag variant="neutral" size="md">
            {totalMeals} meals
          </Tag>
        </div>
      </CardHeader>
    </Card>
  );
};

export default MealPlanDayHeader;
